export { default as PillToggleGroup } from "./PillToggleGroup";

export type { PillToggleProps, PillToggleGroupProps } from "./types";

export const PillToggleVariants = {
  FAILURE: "failure",
  ATTENTION: "attention",
  PENDING: "pending",
  GOOD: "good",
  NEUTRAL: "neutral",
};
